import React from'react';import{i18n}from'@shopgate/engage/core';import{header}from"./CartHeaderWide.style";/**
 * @return {JSX}
 */var CartHeaderWide=function CartHeaderWide(){return React.createElement("div",{className:header},i18n.text('navigation.cart'));};export default CartHeaderWide;